<template>
  <div >
    <Modal v-model="isShow">
      <h3 slot="header" class="modal-header">房型详情</h3>
      <div>
        <div class="left-content">房型名称:</div>
        <div class="right-content">{{data.houseTypeName}}</div>
        <div class="left-content">户型:</div>
        <div class="right-content">{{data.houseType}}</div>
        <div class="left-content">室:</div>
        <div class="right-content">{{data.houseTypeRooms}}</div>
        <div class="left-content">厅:</div>
        <div class="right-content">{{data.houseTypeHall}}</div>
        <div class="left-content">卫:</div>
        <div class="right-content">{{data.houseTypeBathroom}}</div>
        <div class="left-content">房型面积:</div>
        <div class="right-content">{{data.houseTypeArea}}</div>
        <div class="left-content vt">房型描述:</div>
        <div class="right-content">{{data.houseTypeDescription}}</div>
        <div class="left-content vt">户型图:</div>
        <div class="right-content">
          <img v-if="data.houseTypeImage" class="img-item"  :src="data.houseTypeImage" alt="户型图" :key="'keyB'"  />
        </div>
        <div class="left-content vt">房型图:</div>
        <div class="right-content">
          <img class="img-item" v-for="(item,index) in data.houseTypeImages" :src="item" alt="房型图" :key="'keyA'+index"  />
        </div>
        <div class="left-content">备注:</div>
        <div class="right-content">{{data.remark}}</div>


      </div>
    </Modal>
  </div>

</template>
<script>
  export default {
    name: "TypeDetail",
    props:{
      n:{
        type:Number,
        default:0
      },
      data:{
        type:Object,
        default:null
      }
    },
    data(){
      return {
        isShow:false,
      }
    },
    watch:{
      n(){
        this.isShow=true
      }
    }
  }
</script>

<style scoped>
  .left-content{
    display: inline-block;
    width: 15%;
    line-height: 1.8;
    text-align: right;
    margin-right: 10px;
  }
  .right-content{
    display: inline-block;
    width: 70%;
    line-height: 1.8;

  }
  .img-item{
    width: 140px;
    height: 70px;
    margin-right: 10px;
  }
  .vt{
    vertical-align: top;
  }


</style>
